import loadable from '@loadable/component';

/* eslint-disable camelcase */
const COMPONENTS = {
    rich_text_with_title: loadable(() =>
        import('./RichTextWithTitle/RichTextWithTitle')
    ),
    internal_link_list: loadable(() =>
        import('./InternalLinkList/InternalLinkList')
    ),
    two_column_table: loadable(() => import('./TwoColumnTable/TwoColumnTable')),
    faq_with_title: loadable(() => import('./FAQWithTitle/FAQWithTitle')),
};

export default COMPONENTS;
